import { __assign, __awaiter, __generator } from "tslib";
import { alertOnError } from "../components/AlertSnackbar/hooks";
import { getPasswordForDownload } from "../components/DownloadPasswordPopover/hooks";
export function createMultipartUploadForm(file, body) {
    /**
     * when we have a content type of multipart/form-data
     * we need to use the browser's FormData interface
     * and send that instead of a string
     */
    var formData = new FormData();
    formData.append("request", new Blob([JSON.stringify(body)], {
        type: "application/json",
    }));
    if (file) {
        // Supporting file upload only ATM
        formData.append("upload", new File([file], file.name, {
            type: "application/octet-stream",
        }));
    }
    return formData;
}
export var downloadFile = function (data, apiRef) { return __awaiter(void 0, void 0, void 0, function () {
    var handleFileDownload;
    var _a;
    return __generator(this, function (_b) {
        if (!data.id || !apiRef.get)
            return [2 /*return*/];
        if (data.type === "folder" && !!apiRef.getArchive) {
            return [2 /*return*/, apiRef
                    .getArchive({
                    ids: [data.id],
                    format: "zip",
                    transfer_method: "dest-url",
                })
                    .then(function (response) {
                    if (response.status === "Success" && !!response.result.dest_url) {
                        var location_1 = response.result.dest_url;
                        if (location_1) {
                            window.open(location_1, "_blank");
                        }
                    }
                })
                    .catch(function (err) {
                    alertOnError(err);
                    throw err;
                })];
        }
        handleFileDownload = function (body) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(apiRef === null || apiRef === void 0 ? void 0 : apiRef.get))
                    return [2 /*return*/];
                return [2 /*return*/, apiRef
                        .get(__assign({ id: data.id, transfer_method: "dest-url" }, body))
                        .then(function (response) {
                        if (response.status === "Success") {
                            var location_2 = response.result.dest_url;
                            if (location_2) {
                                window.open(location_2, "_blank");
                            }
                        }
                    })
                        .catch(function (err) {
                        alertOnError(err);
                        throw err;
                    })];
            });
        }); };
        if (!!(data === null || data === void 0 ? void 0 : data["vault-password-algorithm"]) ||
            !!((_a = data === null || data === void 0 ? void 0 : data.metadata_protected) === null || _a === void 0 ? void 0 : _a["vault-password-algorithm"])) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var handleCancel = function () {
                        resolve(undefined);
                    };
                    getPasswordForDownload(data, function (password, algo) {
                        return handleFileDownload({
                            password: password,
                        })
                            .then(resolve)
                            .catch(function (err) {
                            return false;
                        });
                    }, handleCancel);
                })];
        }
        return [2 /*return*/, handleFileDownload({})];
    });
}); };
